import { render, staticRenderFns } from "./addClientTask.vue?vue&type=template&id=73f009f7"
import script from "./addClientTask.vue?vue&type=script&lang=js"
export * from "./addClientTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports